import { ExportV2FullResult, GetExportV2Params } from '@go-shared/types/exportV2';
import { apiPost } from '.';

export async function getDailyProgram(
  propertyId: string,
  endpoint: string,
  data: Partial<GetExportV2Params>
): Promise<ExportV2FullResult> {
  return apiPost(`/property/${propertyId}/daily-program/${endpoint}`, data);
}
